import React, { Fragment } from 'react'
import Footer from '../../layouts/Footer'
import Header from '../../layouts/Header'
// import { Image } from '@chakra-ui/react'
import ItemList from '../../components/ItemList'
// import DiscoverBanner from '../../components/DiscoverBanner'
// import BackToTopSwitch from '../../components/BackToTopSwitch'
const Discover = (props) => {
  return (
    <Fragment>
      {/* <div className="disbluebritbg"><Image className="img-fluid" src="/assets/img/discoverbluebrightbg.svg" alt="img" /></div> */}
      {/* header */}
      <Header />
      {/* <DiscoverBanner /> */}
      {/* Popular collections */}
      <ItemList type={props.type}/>
      {/* Footer */}
      <Footer />
      {/* <BackToTopSwitch /> */}
    </Fragment>
  )
}

export default Discover